import { Inject, Pipe, PipeTransform } from '@angular/core';
import { UTILITY_CONFIG } from '../tokens';
import { AtsUtilityConfig } from '../models';

@Pipe({
    name: 'atsSplitPascal',
    standalone: false
})
export class AtsSplitPascalPipe implements PipeTransform {
	constructor(@Inject(UTILITY_CONFIG) private config: AtsUtilityConfig) {}

	transform(items: string | string[]): string;
	transform(items: any): string | string[] {
		return items instanceof Array ? items.map(item => this.modifyValue(item)) : this.modifyValue(items);
	}

	private modifyValue(items: string = '') {
		const exception = (this.config.splitPascalExceptions || []).find(except => except.initialValue === items);
		if (exception) return exception.updatedValue;
		const regex = /([a-z]|[A-Z]|[0-9]){1}([A-Z]){1}/g;
		const matches = regex.exec(items.toString());

		if (!matches || matches.length === 0) {
			return items.toString();
		}
		for (let i = 0; i < matches.length; i++) {
			items = items.replace(regex, '$1 $2');
		}
		return items;
	}
}
